import { render, staticRenderFns } from "./EvaluationReviewed.vue?vue&type=template&id=0510effe&scoped=true"
import script from "./EvaluationReviewed.vue?vue&type=script&lang=js"
export * from "./EvaluationReviewed.vue?vue&type=script&lang=js"
import style0 from "./EvaluationReviewed.vue?vue&type=style&index=0&id=0510effe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0510effe",
  null
  
)

export default component.exports